import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConnectionTypeModel } from "src/app/Model/ConnectionType.model";
import { ConnectionTypeContractModel } from "src/app/Model/ConnectionTypeContract.model";
import { SystemModel } from "src/app/Model/System.model";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
  providedIn: "root",
})
export class ConnectionTypeService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) {
    super(http, lsService,authService);
    this.Component = "ConnectionTypeService";
  }

  public async getConnectionType(){
    let ConnectionType: ConnectionTypeModel[];
    await this.PostData("","ConnectionType","Get").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }
    });
    return ConnectionType;
  }

  public async getConnectionTypeContract(){
    let ConnectionType: ConnectionTypeContractModel[];
    await this.PostData("","ConnectionType","GetConnectionTypeContract").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }
    });
    return ConnectionType;
  }

  public async getIdConnectionType(data){
    let ConnectionType: ConnectionTypeModel;
    await this.PostData(data,"ConnectionType","GetId").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }
    });
    return ConnectionType;
  }

  public async getIdConnectionTypeContract(data){
    let ConnectionTypeContract: ConnectionTypeContractModel;
    await this.PostData(data,"ConnectionType","GetIdContract").then((res) => {
      if(res.head.status != 'False') {
        ConnectionTypeContract = JSON.parse(res.body.response);
      }
    });
    return ConnectionTypeContract;
  }

  public async getConnectionTypeByName(data){
    let ConnectionType: ConnectionTypeModel;
    await this.PostData(data,"ConnectionType","GetConnectionTypeByName").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }
    });
    return ConnectionType;
  }

  public async getSystem(){
    let System: SystemModel[];
    await this.PostData("","ConnectionType","GetSystem").then((res) => {
      if(res.head.status != 'False') {
        System = JSON.parse(res.body.response);
      }
    });
    return System;
  }

  public async postConnectionType(data){
    let ConnectionType: ConnectionTypeModel;
    await this.PostData(data,"ConnectionType","Post").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return ConnectionType;
  }

  public async postConnectionTypeContract(data){
    let ConnectionTypeContract: ConnectionTypeContractModel;
    await this.PostData(data,"ConnectionType","PostContract").then((res) => {
      if(res.head.status != 'False') {
        ConnectionTypeContract = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return ConnectionTypeContract;
  }

  public async putConnectionType(data){
    let ConnectionType: ConnectionTypeModel;
    await this.PostData(data,"ConnectionType","Put").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return ConnectionType;
  }

  public async putConnectionTypeContract(data){
    let ConnectionTypeContract: ConnectionTypeContractModel;
    await this.PostData(data,"ConnectionType","PutContract").then((res) => {
      if(res.head.status != 'False') {
        ConnectionTypeContract = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return ConnectionTypeContract;
  }

  public async deleteConnectionType(data){
    let ConnectionType: ConnectionTypeModel;
    await this.PostData(data,"ConnectionType","Delete").then((res) => {
      if(res.head.status != 'False') {
        ConnectionType = JSON.parse(res.body.response);
      }
    });
    return ConnectionType;
  }

  public async deleteConnectionTypeContract(data){
    let ConnectionTypeContract: ConnectionTypeContractModel;
    await this.PostData(data,"ConnectionType","DeleteContract").then((res) => {
      if(res.head.status != 'False') {
        ConnectionTypeContract = JSON.parse(res.body.response);
      }
    });
    return ConnectionTypeContract;
  }

}
